import { render, staticRenderFns } from "./ShiftPatternDetails.vue?vue&type=template&id=7d8d939b&scoped=true"
import script from "./ShiftPatternDetails.vue?vue&type=script&lang=js"
export * from "./ShiftPatternDetails.vue?vue&type=script&lang=js"
import style0 from "./ShiftPatternDetails.vue?vue&type=style&index=0&id=7d8d939b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d939b",
  null
  
)

export default component.exports